import React from 'react';
import { SolicitationSection } from 'pages/project';
import { ProjectEditorContextProps } from 'pages/project/ProjectEditor/contexts/types';
const Others: React.FC<ProjectEditorContextProps> = props => {
  return <SolicitationSection requestForm requestType="compra" {...props} />;
};

export default Others;
